import { Button, Form, Input, Select } from "antd";
import React from "react";
import { useToasts } from "react-toast-notifications";
import Navbar from "../../components/Navbar";
import { TabBottom } from "../../Layout";
import api from "../../request";
import { decrypt, encrypt } from "../../utils/enkripsi";
import { showLog } from "../../utils/log";
import { socket } from "../../utils/socket";

const { Option } = Select;
const { TextArea } = Input;
export function CallWaiters() {
  const [form] = Form.useForm();
  const { addToast } = useToasts();
  const [sidebar, setSidebar] = React.useState(false);
  const [dataNote, setDataNote] = React.useState([]);
  const [selectedNotes, setSelectedNotes] = React.useState([]);
  const handleNoteChange = (value) => {
    setSelectedNotes(value); // Update state ketika nilai Select berubah
  };

  async function getData() {
    showLog("CallWaiters Masuk getData");
    const result = await api.apiCallWaiters.defaultNote({
      filter: JSON.stringify({
        search1: "",
        search_col1: "all",
        search2: "",
        search_col2: "",
        search3: "",
        search_col3: "",
        sort_col1: "branch_id",
        sort_dir1: "desc",
        sort_col2: "",
        sort_dir2: "asc",
        sort_col3: "",
        sort_dir3: "asc",
        jumlah_baris: 10,
        total_baris: 0,
        aktif: "all",
        halaman: 1,
        kolom_tanggal: "none",
        showUpdated: false,
      }),
    });
    const sii = result.data.map((items, index) => ({
      label: items.id,
      value: items.id,
    }));
    setDataNote(sii);
  }

  React.useEffect(() => {
    showLog("CallWaiters Masuk useEffect 1");
    getData();
  }, []);

  async function onClickCallWaiters(values) {
    showLog("CallWaiters Masuk onClickCallWaiters");
    const meja = localStorage.getItem("meja");
    values["meja"] = meja;
    if (values["note"]) {
      values["note"] = values["note"]?.toString();
    }
    if (values["note_2"]) {
      values["note"] = values["note"]?.toString() + "," + values["note_2"];
    }
    let customerNote = decrypt(
      JSON.parse(localStorage.getItem("customerNote"))
    );
    const newNote = customerNote
      ? `${customerNote};${values.note}`
      : values.note;
    localStorage.setItem("customerNote", JSON.stringify(encrypt(newNote)));
    try {
      // if (values['name'] == "" || !values['name']) {
      //     addToast("Nama Belum diisi", {
      //         appearance: 'error',
      //         autoDismiss: true,
      //     })
      //     return
      // }
      if (values["note"] == "" || !values["note"]) {
        addToast(
          "Catatan tidak boleh kosong. Silakan isi catatan sebelum melanjutkan.",
          {
            appearance: "warning",
            autoDismiss: true,
          }
        );
        return;
      } else {
        const result = await api.apiCallWaiters.save({
          mode: "new",
          detailData: JSON.stringify({
            customer_name: "-",
            // customer_name: values['name'],
            id_klien_note: values["note"],
            table_id: values["meja"],
          }),
        });
        addToast(
          "Panggilan ke Pelayan untuk Meja " +
          localStorage.getItem("meja") +
          " Berhasil Dikirim",
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        form.resetFields(["name", "note", "note_2"]);
        if (socket?.connected) {
          showLog(`Socket Connected With ID = ${socket.id}`);
        }
        socket.emit("call-waiters", {
          branch_id: JSON.parse(localStorage.getItem("dataBranch")).branchID,
        });
      }
    } catch (error) {
      addToast("Maaf ada kesalahan", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  }

  return (
    <div>
      <Navbar
        label="Panggil Waiters"
        sidebar={sidebar}
        setSidebar={(val) => setSidebar(val)}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Menggunakan tinggi viewport agar form berada di tengah layar
          padding: "20px",
          margin: "0 20px",
        }}
      >
        <Form
          form={form}
          initialValues={{
            remember: true,
            size: "small",
          }}
          onFinish={onClickCallWaiters}
          labelCol={{ span: 2, offset: 0 }}
          layout="vertical"
          style={{
            width: "100%", // Lebar form
            maxWidth: "500px", // Maksimum lebar form
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Form.Item name="meja" label="Meja">
            <Input
              disabled={true}
              placeholder="Meja"
              defaultValue={localStorage.getItem("meja")}
            />
          </Form.Item>
          <Form.Item name="note" label="Note">
            <Select
              mode="multiple"
              placeholder="Please select"
              style={{ width: "100%" }}
              onChange={handleNoteChange}
            >
              {dataNote.map((items, index) => (
                <Option value={items.label} key={index}>
                  {items.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="note_2">
            <TextArea
              placeholder="Catatan"
              rows={6}
              style={{ resize: "none" }}
              disabled={selectedNotes.length === 0}
            />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Panggil Waiters
            </Button>
          </Form.Item>
        </Form>
      </div>
      <TabBottom />
    </div>
  );
}
